import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home/index.vue')
  },
  {
    path: '/fansCircle',
    name: 'fansCircle',
    component: () => import('@/views/FansCircle/index.vue')
  },
  {
    path: '/ticket',
    name: 'ticket',
    component: () => import('@/views/Ticket/index.vue')
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import('@/views/Ranking/index.vue')
  },
  {
    path: '/playerRank',
    name: 'playerRank',
    component: () => import('@/views/PlayerRank/index.vue')
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;
